export default __webpack_public_path__ + "39f38361e3563f688a326fd98ce1bf00.ttf";